import React from "react";
import { FormGroup, Label, Button } from "reactstrap";
import style from "./Toolbar.module.scss";
import { DateField } from "../../../../utils";

const Advanced = ({ open, from, to, handleChange, handleSearch, toggle }) => {
  if (open === false) {
    return null;
  }

  return (
    <FormGroup className={style.advanced}>
      <Label>Date range</Label>
      <div className={style.inputs}>
        <DateField label="" name="from" onChange={handleChange} value={from} />
        <div style={{ width: "15px" }} />
        <DateField label="" name="to" onChange={handleChange} value={to} />
      </div>
      <Button type="button" color="primary" onClick={() => handleSearch()}>
        Search
      </Button>

      <Button type="button" color="primary" style={{ marginLeft: "5px" }} onClick={() => toggle()}>
        Hide <i className="fa fa-caret-up" />
      </Button>
    </FormGroup>
  );
};

export default Advanced;
